import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { PencilIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const EditIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <IconButton
        aria-label={t('icon_button.edit_label', 'Edit')}
        ref={ref}
        {...props}
      >
        <PencilIcon color="inherit" fontSize={props.size} />
      </IconButton>
    );
  },
);

EditIconButton.displayName = 'EditIconButton';
export default EditIconButton;
